import { create } from "zustand";
import { report } from "../api_layer/api";
import secureLocalStorage from "react-secure-storage";

export const useReportsStore = create((set) => ({
reportData:[],
error:null,
postReportsData: async (payload, setToaster) => {
    try {
      await report(payload);
      setToaster("Reports",`Your report will be sent to your email ${secureLocalStorage.getItem("alternate_email")} shortly`, "success")
    } catch (error) {
        setToaster("Reports",`Report sending failed`, "danger")
      set({ error: error.message});
    }
  },
}));